import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';
import { aboutInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-sun-line text-xl text-accent-500"></i>
              </div>
              <span className="font-heading font-bold text-base text-background-50">亚洲一级日本</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {aboutInfo.slogan}。专业的分级筛选与精准推荐，为您提供最优质的亚洲一级内容体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <a href="#footer-categories" className="text-background-50 no-underline">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <a href="#footer-links" className="text-background-50 no-underline">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200">
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              <a href="#footer-contact" className="text-background-50 no-underline">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>{aboutInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>{aboutInfo.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span className="leading-relaxed">{aboutInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 亚洲一级日本精选内容导航平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#weibo" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-300/20 hover:bg-accent-500/30 transition-colors duration-200" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-sm text-foreground-300"></i>
            </a>
            <a href="#wechat" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-300/20 hover:bg-accent-500/30 transition-colors duration-200" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-sm text-foreground-300"></i>
            </a>
            <a href="#twitter" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-300/20 hover:bg-accent-500/30 transition-colors duration-200" aria-label="Twitter" rel="nofollow">
              <i className="ri-twitter-x-line text-sm text-foreground-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}